export default __webpack_public_path__ + "static/media/HelveticaNowText-Regular.3561cdb0.otf";